"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonStorageItem = void 0;
var JsonStorageItem = (function () {
    function JsonStorageItem(storageItem) {
        this.storageItem = storageItem;
    }
    JsonStorageItem.prototype.get = function () {
        var jsonValue = this.storageItem.get();
        if (!jsonValue) {
            return null;
        }
        try {
            return JSON.parse(jsonValue);
        }
        catch (e) {
            return null;
        }
    };
    JsonStorageItem.prototype.set = function (value) {
        this.storageItem.set(JSON.stringify(value));
    };
    JsonStorageItem.prototype.remove = function () {
        this.storageItem.remove();
    };
    return JsonStorageItem;
}());
exports.JsonStorageItem = JsonStorageItem;
//# sourceMappingURL=json-storage-item.js.map